export default __webpack_public_path__ + "images/2de581c0e87d3dc7e4f4f4fa8ed40860-apple.png";